




























































import { Component, Prop, Mixins } from "vue-property-decorator";
import i18n from "@/i18n";

// Mixins
import HasValidation from "@/mixins/HasValidation";

@Component
export default class DefaultValueField extends Mixins(HasValidation) {
  // Props

  @Prop({ required: true })
  public value!: any;

  @Prop({ required: true })
  public defaultValue!: any;

  @Prop({ default: "text" })
  public type!: "text" | "number";

  @Prop({ default: "" })
  public rules!: string;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: "" })
  public label!: string;

  @Prop({ default: "" })
  public vid!: string;

  @Prop({ default: "" })
  public vname!: string;

  @Prop({ default: null })
  public explanation!: string;

  @Prop({ default: i18n.t("_.default_value") })
  public defaultValueLabel!: string;

  @Prop({ default: i18n.t("_action.reset_to_default") })
  public useDefaultLabel!: string;

  // Getter

  public get fieldValue() {
    return this.value;
  }

  // Setter

  public set fieldValue(value) {
    this.$emit("input", value === "" ? null : value);
  }
}
